export const DAY_REINITIALIZE = 26;
export const WITHOUT_TRANSMIT = 'Sin transmitir';
export const TRANSMIT = 'TRANSMITIDA';
export const FINALIZED = 'FINALIZADO';
export const REFUSED = 'RECHAZADA';
export const PARTIALLY_TRANSMITED = 'TRANSMITIDA PARCIALMENTE';
export const CONFIRMED_STATUS = ['3', '5', '6', '7', '9'];

export const ELECTRONIC_PAYROLL_NOVELTY_TRANSMISION_ERROR =
    'Hubo un error durante la transmisión de las novedades especiales. Por favor ingrese al portal de nomina electronica y transmitalas mediante este portal.';

export const ELECTRONIC_PAYROLL_INSUFFICIENT_DOCUMENTS = 'Identificamos que intentas cargar';

export const ELECTRONIC_PAYROLL_WITHOUT_DOCUMENTS =
    'Te quedaste sin saldo. Por favor adquiere un plan de documentos de Nómina electrónica para realizar la transmisión.';

export const ELECTRONIC_PAYROLL_BUY_NEW_PLANS =
    'Identificamos que no tienes documentos suficientes para transmitir. Te invitamos a adquirir un plan que incluya la transmisión haciendo clic en Comprar. Si ya realizaste la compra, selecciona Volver y luego elige transmitir.';

export const ELECTRONIC_PAYROLL_SERVICE_ERROR = 'En este momento no podemos procesar su información, inténtelo más tarde';
